import { render, staticRenderFns } from "./SquaredButton.vue?vue&type=template&id=e30d3a28"
import script from "./SquaredButton.vue?vue&type=script&lang=js"
export * from "./SquaredButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports